import React, { useState } from "react";
import { Mail, ArrowRight, Loader2 } from "lucide-react";
import { requestOtp } from "../../api/client";

export default function OtpRequestForm({ onSuccess, ctaLabel }) {
  const [email, setEmail]     = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState("");

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!isValidEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await requestOtp(email.trim().toLowerCase());
      onSuccess(email.trim().toLowerCase());
    } catch (err) {
      const msg = err.response?.data?.detail || err.message || "Failed to send OTP. Please try again.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} noValidate>
      {error && (
        <div className="auth-banner error">
          <span>⚠</span> {error}
        </div>
      )}

      <div className="auth-field">
        <label htmlFor="auth-email">Email address</label>
        <input
          id="auth-email"
          type="email"
          placeholder="you@company.com"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setError(""); }}
          autoComplete="email"
          autoFocus
        />
        <p className="auth-field-hint">
          We'll send a one-time password to this address.
        </p>
      </div>

      <button
        type="submit"
        className="auth-btn-primary"
        disabled={loading || !email.trim()}
      >
        {loading ? (
          <><Loader2 size={16} className="spin" /> Sending OTP…</>
        ) : (
          <><Mail size={16} /> {ctaLabel || "Send One-Time Password"} <ArrowRight size={15} /></>
        )}
      </button>
    </form>
  );
}
